import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eb6b27c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "html-input" }
const _hoisted_2 = { class: "label-title-icon" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "ai-button-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-html5" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  id: "htmlEditorToolbarFooter"
}

import {
  DxHtmlEditor,
  DxToolbar,
  DxMediaResizing,
  DxItem,
  DxImageUpload,
} from "devextreme-vue/html-editor";
import { ref, computed, watch, onMounted } from "vue";
import SymbolSelectorModal from "./symbol-selector-modal.vue";
import EditHtmlModal from "./edit-html-modal.vue";
import Quill from "devextreme-quill";


export default /*#__PURE__*/_defineComponent({
  __name: 'html-editor',
  props: {
  /**
   * The string value used with `v-model` to bind the component state.
   * @type {string}
   * @required
   */
  modelValue: {
    type: String,
    required: true,
  },
  /**
   * The label displayed for the html editor control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Determines if the html editor control should be in read-only mode.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * The text to be inserted at the current cursor position.
   * @type {String}
   * @default ''
   */
  insertTextAtCursorPosition: {
    type: String,
    default: "",
  },
  /**
   * Defines the height of the component.
   * @type {String}
   * @default '360px'
   */
  height: {
    type: String,
    default: "360px",
  },
  /**
   * Controls the visibility of the AI modal.
   * @type {Boolean}
   * @default false
   */
  displayAIModal: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {string} value - Indicates whether the modal has been changed.
   */
  "update:modelValue",
  /**
   * Triggered when the HTML editor gains focus.
   * Can be used to handle UI changes or fetch necessary data.
   */
  "onFocused",
  /**
   * Triggered when the AI icon is clicked.
   * Can be used to open an AI-powered modal or trigger related actions.
   */
  "aiIconClick",
],
  setup(__props, { emit }) {

const props = __props;



const htmlMarkup = computed({
  get: () => props.modelValue,
  set: (val: string) => emit("update:modelValue", val),
});



onMounted(() => {
  setToolbarPosition();
});

watch(
  () => window.screen.width,
  () => {
    setToolbarPosition();
  },
);

const setToolbarPosition = () => {
  if (window.screen.width <= 600) {
    htmlToolbarContainer.value = "#htmlEditorToolbarFooter";
  } else {
    htmlToolbarContainer.value = "";
  }
};

const sizeValues = ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"];
const fontValues = [
  "Arial",
  "Courier New",
  "Georgia",
  "Impact",
  "Lucida Console",
  "Tahoma",
  "Times New Roman",
  "Verdana",
];
const headerValues = [false, 1, 2, 3, 4, 5];
const isMultiline = ref(true);
const fontSizeOptions = { inputAttr: { "aria-label": "Font size" } };
const fontFamilyOptions = { inputAttr: { "aria-label": "Font family" } };
const headerOptions = { inputAttr: { "aria-label": "Font family" } };
const displayIconSelector = ref(false);
const cursorPosition = ref();
const displayEditHtmlModal = ref(false);
const htmlEditor = ref<DxHtmlEditor>();
const htmlToolbarContainer = ref("");

const symbolSelected = (symbol: string) => {
  if (!cursorPosition.value) {
    htmlMarkup.value = htmlMarkup.value + symbol;
    return;
  }

  htmlEditor.value?.instance?.insertText(
    cursorPosition.value.index,
    symbol,
    {},
  );
};

const openSymbolModal = () => {
  cursorPosition.value = htmlEditor.value?.instance?.getSelection();
  displayIconSelector.value = true;
};

const htmlUpdated = (updatedHtml: string) => {
  htmlMarkup.value = updatedHtml;
};

watch(
  () => props.insertTextAtCursorPosition,
  () => {
    if (props.insertTextAtCursorPosition == "") {
      return;
    }

    if (!cursorPosition.value) {
      htmlMarkup.value = htmlMarkup.value + props.insertTextAtCursorPosition;
      return;
    }

    htmlEditor.value?.instance?.insertText(
      cursorPosition.value.index,
      props.insertTextAtCursorPosition,
      {},
    );
  },
);

const getCursorPosition = () => {
  cursorPosition.value = htmlEditor.value?.instance?.getSelection();
};

/* By default hitting enter will create new <p> tags.
 * However, this leads to double lines appearing when the recipient views the email
 * The suggested workaround is to configure the underlying library Quill to use divs instead of p tags
 * https://supportcenter.devexpress.com/ticket/details/t753871/htmleditor-how-to-insert-the-br-tag-when-the-enter-key-is-pressed */
let Block = Quill.import("blots/block");
Block.tagName = "div";
Quill.register(Block);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(props.label), 1),
        _createElementVNode("div", _hoisted_4, [
          (props.displayAIModal)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "fa-sharp fa-thin fa-microchip-ai ai-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('aiIconClick')))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_unref(DxHtmlEditor), {
        ref_key: "htmlEditor",
        ref: htmlEditor,
        onValueChanged: getCursorPosition,
        value: htmlMarkup.value,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((htmlMarkup).value = $event)),
        height: props.height,
        valueType: "html",
        readOnly: props.readOnly,
        onFocusIn: _cache[3] || (_cache[3] = ($event: any) => (emit('onFocused')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxMediaResizing), { enabled: true }),
          _createVNode(_unref(DxImageUpload), {
            tabs: ['file', 'url'],
            "file-upload-mode": "base64"
          }),
          (!props.readOnly)
            ? (_openBlock(), _createBlock(_unref(DxToolbar), {
                key: 0,
                multiline: isMultiline.value,
                container: htmlToolbarContainer.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxItem), { name: "undo" }),
                  _createVNode(_unref(DxItem), { name: "redo" }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), {
                    name: "size",
                    "accepted-values": sizeValues,
                    options: fontSizeOptions
                  }),
                  _createVNode(_unref(DxItem), {
                    name: "font",
                    "accepted-values": fontValues,
                    options: fontFamilyOptions
                  }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), { name: "bold" }),
                  _createVNode(_unref(DxItem), { name: "italic" }),
                  _createVNode(_unref(DxItem), { name: "strike" }),
                  _createVNode(_unref(DxItem), { name: "underline" }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), { name: "alignLeft" }),
                  _createVNode(_unref(DxItem), { name: "alignCenter" }),
                  _createVNode(_unref(DxItem), { name: "alignRight" }),
                  _createVNode(_unref(DxItem), { name: "alignJustify" }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), { name: "orderedList" }),
                  _createVNode(_unref(DxItem), { name: "bulletList" }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), {
                    name: "header",
                    "accepted-values": headerValues,
                    options: headerOptions
                  }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), { name: "color" }),
                  _createVNode(_unref(DxItem), { name: "background" }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), { name: "link" }),
                  _createVNode(_unref(DxItem), { name: "image" }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), { name: "clear" }),
                  _createVNode(_unref(DxItem), { name: "codeBlock" }),
                  _createVNode(_unref(DxItem), { name: "blockquote" }),
                  _createVNode(_unref(DxItem), { name: "separator" }),
                  _createVNode(_unref(DxItem), { name: "symbols" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "custom-header-icon",
                        onClick: openSymbolModal,
                        id: "symbolsIcon"
                      }, " Ω ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxItem), { name: "html" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "custom-header-icon",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (displayEditHtmlModal.value = true)),
                        id: "symbolsIcon"
                      }, _hoisted_6)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxItem), { name: "increaseIndent" }),
                  _createVNode(_unref(DxItem), { name: "decreaseIndent" }),
                  _createVNode(_unref(DxItem), { name: "subscript" }),
                  _createVNode(_unref(DxItem), { name: "superscript" }),
                  _createVNode(_unref(DxItem), { name: "insertTable" }),
                  _createVNode(_unref(DxItem), { name: "deleteTable" }),
                  _createVNode(_unref(DxItem), { name: "insertRowAbove" }),
                  _createVNode(_unref(DxItem), { name: "insertRowBelow" }),
                  _createVNode(_unref(DxItem), { name: "deleteRow" }),
                  _createVNode(_unref(DxItem), { name: "insertColumnLeft" }),
                  _createVNode(_unref(DxItem), { name: "insertColumnRight" }),
                  _createVNode(_unref(DxItem), { name: "deleteColumn" })
                ]),
                _: 1
              }, 8, ["multiline", "container"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "height", "readOnly"]),
      (htmlToolbarContainer.value != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _createVNode(EditHtmlModal, {
      modelValue: displayEditHtmlModal.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((displayEditHtmlModal).value = $event)),
      "displayed-html": htmlMarkup.value,
      onHtmlUpdated: htmlUpdated
    }, null, 8, ["modelValue", "displayed-html"]),
    _createVNode(SymbolSelectorModal, {
      modelValue: displayIconSelector.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((displayIconSelector).value = $event)),
      onSymbolSelected: symbolSelected
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})